// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","image":"Card_image__VZTa-","title":"Card_title__Ip0in","number":"Card_number__3y0dr","_horizontal":"Card__horizontal__2UIWj","text":"Card_text__nO5sW"};